export default __webpack_public_path__ + "static/plp--reposado--hover-8378547faed978b38b2791c2f83b1377.jpg";